module.exports = __webpack_public_path__ + "fonts/992903b7b5f7bfeb9bc3edfc69fbffbe.txt";